<template>
  <Modal v-model="showModal" :mask-closable="false" width="600px">
    <div slot="header">编辑珠海三润云平台账户信息</div>
    <Form ref="form" :model="form" class="form" :rules="rules" :label-width="100">
      <FormItem prop="name" label="账户名称">
        <Input ref="name" type="text" maxlength="20" v-model="form.name" placeholder="请输入名称">
        </Input>
      </FormItem>
      <FormItem prop="serverIp" label="服务器IP">
        <Input ref="serverIp" type="text" maxlength="30" v-model="form.serverIp" placeholder="请输入接口IP">
        </Input>
      </FormItem>
      <FormItem prop="serverPort" label="服务器端口">
        <Input ref="serverPort" type="number" maxlength="15" v-model="form.serverPort" placeholder="请输入服务端口">
        </Input>
      </FormItem>
      <FormItem prop="userName" label="用户名">
        <Input ref="userName" type="text" maxlength="15" v-model="form.userName" placeholder="请输入用户名">
        </Input>
      </FormItem>
      <FormItem prop="userPswd" label="用户密码">
        <Input ref="userPswd" type="text" maxlength="15" v-model="form.userPswd" placeholder="请输入用户密码">
        </Input>
      </FormItem>
    </Form>
    <div slot="footer">
      <Button style="margin-right: 8px" @click="cancel">取消</Button>
      <Button type="primary" :loading="loading" @click="ok">保存</Button>
    </div>
  </Modal>
</template>
<script>
  export default {
    name: 'ModalRoleEdit',
    components:{
    },
    model: {
      prop: 'value',
      event: 'showChanged'
    },
    props: {
      value: {
        type: Boolean,
        default: false
      },
      item: {
        type: Object,
        default(){ return {};}
      }
    },
    data () {
      return {
        showModal: this.value,
        loading: false,
        isAdd: false,
        index: -1,
        form: {
          id: 0,
          name: '',
          serverIp: '',//服务器IP
          serverPort: 8088,//服务器端口
          userName: 'kf1',//用户名
          userPswd: '111111',//用户密码
        },
        rules: {
          serverIp: [
            { required: true, message: '服务器IP不能为空', trigger: 'blur' },
            { type: 'string', min: 7, max: 30, message: '服务器IP长度必须7-15个字符', trigger: 'blur' }
          ],
          name: [
            { required: true, message: '名称不能为空', trigger: 'blur' },
            { type: 'string', min: 2, max: 20, message: '名称长度必须2 - 20个字符', trigger: 'blur' }
          ],
          userName: [
            { required: true, message: '用户名不能为空', trigger: 'blur' },
            { type: 'string', min: 2, max: 20, message: '用户名长度必须2 - 20个字符', trigger: 'blur' }
          ],
          userPswd: [
            { required: true, message: '用户密码不能为空', trigger: 'blur' },
            { type: 'string', min: 2, max: 20, message: '用户密码长度必须2 - 20个字符', trigger: 'blur' }
          ],
        },
      }
    },
    watch: {
      // item(newVal){
        
      // },
      value(newVal) {
        this.showModal = newVal;
        if(this.showModal){
          // console.log('edit item', this.item)
          this.isAdd = this.item.isAdd;
          if(!this.isAdd){
            this.form.id = this.item.data.id;
            this.form.serverIp = this.item.data.serverIp;
            this.form.serverPort = this.item.data.serverPort;
            this.form.name = this.item.data.name;
            this.form.userName = this.item.data.userName;
            this.form.userPswd = this.item.data.userPswd;
          }else{
            this.form.id = 0;
            this.form.name = '';
            this.form.serverIp = '';
            this.form.serverPort = 8088;
            this.form.userName = 'kf1';
            this.form.userPswd = '111111';
          }
        }
      },
      showModal(val){
        this.$emit('showChanged', val);
      }
    },
    methods: {
      ok: async function () {
        let result = await this.$refs.form.validate();
        if(!result){
          // this.hideLoading();
          return;
        }
        this.loading = true;
        let res = await this.$axios.post(`//${this.domains.trans}/pole/account/SaveSanrun`, this.form);
        this.loading = false;
        if(res.code !== 0){
          // this.$Message.error(res.data);
          return;
        }
        this.form.id = res.data;
        this.$Message.info('保存成功');
        setTimeout(() => {
          this.showModal = false;
          this.$emit('saved');
        }, 800);
      },
      cancel () {
        this.showModal = false;
        this.$refs.form.resetFields();
      },
    }
  }
</script>
<style scoped>
  .form{
    height: calc(100%);
    overflow: auto;
  }
  .readonly{
    background: #eee
  }
</style>